module.exports = __webpack_public_path__ + "img/certificate2.4acf7b16.jpeg";